import request from '@/config/axios'

/** 预售退定金审核 */
export interface PresaleDepositCancelVO {
  id?: number
  no?: string
  orderId?: number
  userId?: number
  shopId?: number
  depositPrice?: number
  depositPayOrderId?: number
  applyReason?: string
  status?: number
  refundDeposit?: boolean
  auditReason?: string
  auditorId?: number
  auditTime?: string
  payRefundId?: number
  refundTime?: string
  createTime?: string
}

/** 状态：0待审 10通过退款中 20通过不退已关单 30驳回 40退款完成 */
export const DEPOSIT_CANCEL_STATUS = [
  { label: '待审核', value: 0 },
  { label: '通过退款中', value: 10 },
  { label: '通过不退已关单', value: 20 },
  { label: '已驳回', value: 30 },
  { label: '退款完成已关单', value: 40 }
] as const

export const getDepositCancelStatusLabel = (status?: number | null) => {
  return DEPOSIT_CANCEL_STATUS.find((i) => i.value === status)?.label ?? '-'
}

export const getDepositCancelPage = async (params: Recordable) => {
  return await request.get({ url: `/trade/presale-deposit-cancel/page`, params })
}

export const getDepositCancel = async (id: number) => {
  return await request.get({ url: `/trade/presale-deposit-cancel/get`, params: { id } })
}

/** auditResult: 1通过退定金 2通过不退 3驳回 */
export const auditDepositCancel = async (data: {
  id: number
  auditResult: number
  auditReason?: string
}) => {
  return await request.put({ url: `/trade/presale-deposit-cancel/audit`, data })
}
